<template>
    
    <div class="cell" :class="css">
        <span class="cell-value"><slot/></span>

    </div>

    
</template>

<script>

export default ({

    props: {        
        type: String
    },

    computed: {
        
        css: function() {
            let cssClasses = []
            if ( this.type ) {
                this.type.split(' ').forEach((type) => {
                    cssClasses.push(`cell--${type}`)
                })
            }
            return cssClasses.join(' ')
        }
    },
})
</script>


<style>

.cell-value {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


</style>